<template>
  <div>
<!--    <el-row  v-for="item in ziliaoAll">-->
<!--      <el-col :span="4" :offset="5" style="margin-top: 40px">-->
<!--        <el-card shadow="always">-->
<!--          <div slot="header" class="clearfix" style="text-align: center">-->
<!--            {{ }}资料下载-->
<!--          </div>-->
<!--          <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->

<!--        </el-card>-->
<!--      </el-col>-->

<!--      <el-col :span="4" :offset="1" >-->

<!--        <el-card shadow="always">-->
<!--        <div slot="header" class="clearfix" style="text-align: center">-->
<!--          {{ }}资料下载-->
<!--        </div>-->
<!--        <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->

<!--      </el-card>-->
<!--      </el-col>-->

<!--      <el-col :span="4"  :offset="1">-->
<!--        <el-card shadow="always">-->
<!--          <div slot="header" class="clearfix" style="text-align: center">-->
<!--            {{ }}资料下载-->
<!--          </div>-->
<!--          <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->

<!--        </el-card>-->
<!--      </el-col>-->
<!--    </el-row>-->

<!--    <el-row  style="margin-top: 40px">-->
<!--      <el-col :span="4" :offset="5" >-->
<!--        <el-card shadow="always">-->
<!--          <div slot="header" class="clearfix" style="text-align: center">-->
<!--            {{ }}资料下载-->
<!--          </div>-->
<!--          <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->

<!--        </el-card>-->
<!--      </el-col>-->

<!--      <el-col :span="4" :offset="1" >-->
<!--        <el-card shadow="always">-->
<!--          <div slot="header" class="clearfix" style="text-align: center">-->
<!--            {{ }}资料下载-->
<!--          </div>-->
<!--          <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->

<!--        </el-card>-->
<!--      </el-col>-->

<!--      <el-col :span="4"  :offset="1">-->
<!--        <el-card shadow="always">-->
<!--          <div slot="header" class="clearfix" style="text-align: center">-->
<!--            {{ }}资料下载-->
<!--          </div>-->
<!--          <el-link type="success">基于Java的商城网站系统设计与实现</el-link>-->
<!--        </el-card>-->
<!--      </el-col>-->

<!--    </el-row>-->
    <el-row  >
      <el-col :span="4"  style="margin-top: 40px" v-for="(value, key) in ziliaoAll" :offset="(key % 3 ===0) ?5:1" :key="key">
        <el-card shadow="always" v-for="(v2,k2) in value">
          <div slot="header" class="clearfix" style="text-align: center">
             {{k2}}资料下载
          </div>
          <div v-for="(v3,k3) in v2" style="text-align: left">
          <el-link type="success"  :href="'/downloads/'+v3">
            {{v3}}
          </el-link>
          </div>
        </el-card>
      </el-col>

    </el-row>




  </div>
</template>

<script>
import http from "@/utils/http-base";
export default {
  name: "index-ziliao",
  data(){
    return{
      ziliaoAll:[],
    }
  },
  methods:{
    getFile() {
      http.get("/api/down/").then(res=>{
        for (let key in res.data.data){
          this.ziliaoAll.push({
            [key] :res.data.data[key]
          })
        }
      })
    },
  },
  mounted() {
    this.getFile()
  }

}
</script>

<style scoped>


</style>